import React from 'react';
import { Box } from '@mui/material';
import { motion } from 'framer-motion';

const ImageThumbnail = ({ image, active, onClick }) => {
  return (
    <motion.div 
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      onClick={onClick}
    >
      <Box
        component="img"
        src={image.url}
        alt="Thumbnail"
        sx={{
          width: 80,
          height: 60,
          objectFit: "cover",
          borderRadius: "4px",
          cursor: "pointer",
          border: active ? "2px solid" : "1px solid",
          borderColor: active ? "#001d3d" : "#e0e0e0",
          opacity: active ? 1 : 0.7,
          transition: "all 0.2s ease",
        }}
      />
    </motion.div>
  );
};

export default ImageThumbnail;